export const ConsignmentStatus = [
    {
        id: 1,
        name: 'Requested',
        color: '#A6A6A6'
    },
    {
        id: 2,
        name: 'Actioned',
        color: '#cfb5ef'
    },
    {
        id: 3,
        name: 'Driver on route',
        color: '#cfb5ef'
    },
    {
        id: 4,
        name: 'Driver on site',
        color: '#E46C0A'
    },
    {
        id: 5,
        name: 'Despatched',
        color: '#E46C0A'
    },

    {
        id: 6,
        name: 'Collection depot',
        color: '#00CCFF'
    },
    {
        id: 7,
        name: 'Hub',
        color: '#00CCFF'
    },
    {
        id: 8,
        name: 'In delivery depot',
        color: '#00CCFF'
    },
    {
        id: 9,
        name: 'Goods on board',
        color: '#DBD600'
    },    
    {
          id: 10,
          name: 'Out for delivery',
          color: '#DBD600'
    },
    {
      id: 17,
      name: 'On Site (Delivery)',
      color: '#DBD600'
    },
    {
        id: 11,
        name: 'Delivered',
        color: '#00B050'
    },
    {
        id: 12,
        name: 'Failed',
        color: '#FF66CC'
    },
    {
        id: 13,
        name: 'Short',
        color: '#996633'
    },
    {
        id: 14,
        name: 'Overdue',
        color: '#FF0000'
  },  
];

export function getStatusById(id: number): string {
    const result = ConsignmentStatus.find(s => s.id === id);
    return result ? result.name : undefined;
}

export enum ConsignmentStatusType {
    Requested = 1,
    Actioned = 2,
    DriverEnRoute = 3,
    DriverEnSite = 4,
    Despatched = 5,
    CollectionDepot = 6,
    Hub = 7,
    InDeliveryDepot = 8,
    GoodsOnBoard = 9,
    OutForDelivery = 10,
    OnSiteDelivery = 17,
    Delivered = 11,
    Failed = 12,
    Short = 13,
    Overdue = 14,
    Paid = 15,
    PartiallyPaid = 16,   

}
